<template>
  <div>
    <div class="card">
      <div class="card-header border-bottom">
        <h4 class="card-title">Change Password</h4>
      </div>
      <div class="alert alert-danger" role="alert" v-if="errorMessage">
        {{ errorMessage }}
      </div>
      <div
        class="alert alert-danger"
        role="alert"
        v-if="validationError.length > 0"
      >
        <span> Your password must contains : </span>
        <ul>
          <li v-for="(reg, index) in validationError" :key="index">
            {{ reg }}
          </li>
        </ul>
      </div>
      <div class="alert alert-success" role="alert" v-if="successMessage">
        {{ successMessage }}
      </div>
      <div class="card-body pt-1">
        <div class="row row__inline">
          <div class="col-12 col-sm-6 mb-1">
            <label class="form__label" for="account-old-password"
              >Current password</label
            >
            <div class="form__password">
              <input
                type="password"
                class="form-control input__password"
                v-model="oldPassword"
                placeholder="Enter current password"
              />
              <div class="cursor__pointer" @click="showHide">
                <i class="fa fa-eye-slash" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-1">
            <label class="form__label" for="account-new-password"
              >New Password</label
            >
            <div class="form__password">
              <input
                type="password"
                v-model="newPassword"
                class="form-control input__password"
                placeholder="Enter new password"
              />
              <div class="cursor__pointer" @click="showHide">
                <i class="fa fa-eye-slash" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-1">
            <label class="form__label" for="account-retype-new-password"
              >Retype New Password</label
            >
            <div class="form__password">
              <input
                type="password"
                class="form-control input__password"
                v-model="confirmPassword"
                placeholder="Confirm your new password"
              />
              <div class="cursor__pointer" @click="showHide">
                <i class="fa fa-eye-slash" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <div class="col-12">
            <p class="fw-bolder">Password requirements:</p>
            <ul class="ps-1 ms-25">
              <li class="mb-50">
                Minimum 8 characters long - the more, the better
              </li>
              <li class="mb-50">At least one lowercase character</li>
              <li>At least one number, symbol, or whitespace character</li>
            </ul>
          </div>
          <div class="col-12">
            <button type="button" @click="save" class="btn btn__save">
              Save changes
            </button>
            <button type="button" @click="reset" class="btn btn__discard">
              Discard
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header border-bottom">
        <h4 class="card-title">Delete Account</h4>
      </div>
      <div class="card-body py-2 my-25">
        <div class="alert alert-warning">
          <h4 class="alert-heading">
            Are you sure you want to delete your account?
          </h4>
          <div class="alert-body fw-normal">
            Once you delete your account, there is no going back. Please be
            certain.
          </div>
        </div>

        <div>
          <button type="button" @click="deleteAccount" class="btn btn__delete">
            Deactivate Account
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { Firebase, db } from "../../../firebaseDB";
import Swal from "sweetalert";
export default {
  data() {
    return {
      oldPassword: "",
      confirmPassword: "",
      newPassword: "",
      errorMessage: "",
      successMessage: "",
      validationError: [],
    };
  },
  computed: {},

  methods: {
    reset() {
      this.oldPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
      (this.errorMessage = ""), (this.successMessage = "");
    },
    showHide() {
      if ($(".input__password").attr("type") == "text") {
        $(".input__password").attr("type", "password");
        $("i").addClass("fa-eye-slash");
        $("i").removeClass("fa-eye");
      } else if ($(".input__password").attr("type") == "password") {
        $(".input__password").attr("type", "text");
        $("i").removeClass("fa-eye-slash");
        $("i").addClass("fa-eye");
      }
    },
    save() {
      (this.errorMessage = ""), (this.successMessage = "");
      var pattern = new RegExp(
        "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$"
      );
      if (this.oldPassword === "") {
        this.errorMessage = "Please enter your current password";
      } else if (this.newPassword.length < 8) {
        this.errorMessage = "New Password should be at least 8 characters";
      } else if (this.newPassword != this.confirmPassword) {
        this.errorMessage = "your new password and confirmation does not match";
      } else if (!pattern.test(this.newPassword)) {
        this.validationError = [
          "One uppercase (A-Z)",
          "One lowercase (a-z)",
          "One number (0-9)",
          "One special character (-+_!@#$%^&*.,?)",
        ];
      } else {
        var user = Firebase.auth().currentUser;
        let self = this;
        user
          .updatePassword(this.newPassword)
          .then(function () {
            Firebase.auth()
              .signInWithEmailAndPassword(user.email, self.newPassword)
              .then((firebaseUser) => {
                    self.$store.state.user = {
                            ...self.$store.state.user,
                            id: firebaseUser.user.uid
                         }
                self.successMessage = "Your password is updated successfully !";
              })
              .catch(function (error) {
                self.errorMessage = error.errorMessage;
              });
          })
          .catch(function (error) {
            self.errorMessage = error.errorMessage;
          });
      }
    },
    deleteAccount() {
      Swal({
        title: `Are you sure you want to delete this account ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        focusConfirm: false,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
      }).then((result) => {
        if (result) {
          let userID = this.$store.state.user.id;
          this.$store.dispatch("userSignOut");
          db.ref(`users/${userID}`).remove();
          this.$router.push({ name: "" });
        }
      });
    },
  },
};
</script>

<style lang="scss" >
.card {
  border: 0 solid rgba(34, 41, 47, 0.125);
  border-radius: 0.428rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.125);
}
.card-header {
  background-color: #fff;
}
.card-title {
  font-weight: 500;
  font-size: 1.285rem;
  margin-bottom: 0px;
}
.form__password {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  &:focus-within {
    border-color: #7367f0;
    box-shadow: none;
  }
}

.form-control.input__password {
  display: block;
  width: 100%;
  padding: 0.771rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  appearance: none;
  border-radius: 0.357rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.form__password:focus-within .form-control,
.form__password:focus-within .cursor__pointer {
  border-color: #7367f0;
  box-shadow: none;
}
.cursor__pointer {
  display: flex;
  align-items: center;
  padding: 0.571rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  text-align: center;
  white-space: nowrap;
  background-color: #fff;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  border-left: none;
  cursor: pointer;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.fw-bolder {
  font-weight: 600 !important;
}
.ps-1 {
  padding-left: 1rem !important;
}
.ms-25 {
  margin-left: 0.25rem !important;
}
.btn__save {
  border: 1px solid transparent;
  padding: 0.786rem 1.5rem;
  font-size: 1rem;
  border-radius: 0.358rem;
  border-color: #7367f0 !important;
  background-color: #7367f0 !important;
  color: #fff !important;
}
.btn__discard {
  border: 1px solid transparent;
  padding: 0.786rem 1.5rem;
  font-size: 1rem;
  border-radius: 0.358rem;
  border: 1px solid #82868b !important;
  background-color: transparent;
  color: #82868b;
}
.btn__delete {
  border: 1px solid transparent;
  padding: 0.786rem 1.5rem;
  font-size: 1rem;
  border-radius: 0.358rem;
  border-color: #ea5455 !important;
  background-color: #ea5455 !important;
  color: #fff !important;
}
.alert-warning {
  background: rgba(255, 159, 67, 0.12) !important;
  color: #ff9f43 !important;
}
.row__inline{display:inline}
.alert.alert-danger, .alert.alert-success{

  width: 50%;
  margin-top: 10px;
  align-self: center;
}
</style>


// WEBPACK FOOTER //
// src/views/user_profile/info/security.vue